import { trialPeriodEndDate } from '@util/TrialDateUtils';
import React, { FunctionComponent } from 'react';
import { PLAN_INTERVALS } from '../../businessLogic/PlansData';
import { useAppStore } from '../../store/Store';
import { PricingSelector } from '../../store/pricing/PricingActions';
import { PurchaseSelector } from '../../store/purchase/PurchaseActions';
import * as images from '../assets/Images';
import { LightContainer } from '../styles/ColoredContainers';
import { Body } from '../styles/Typography';

export const Disclaimer: FunctionComponent = () => {
  const { hasTrial, trialPeriodDays, trialEndDate, hasOneTimeDiscount, planInterval, prices } =
    useAppStore((state) => ({
      hasTrial: PurchaseSelector.hasTrial(state.purchase),
      trialPeriodDays: state.purchase.trialPeriodDays,
      trialEndDate: trialPeriodEndDate(state.purchase.trialPeriodDays),
      hasOneTimeDiscount: PricingSelector.hasOneTimeDiscount(state.pricing),
      planInterval: PLAN_INTERVALS[state.purchase.plan],
      prices: PricingSelector.prices(state),
    }));

  const { initialPlanPrice, ongoingPlanPrice } = prices || {};

  let purchaseChargeText = hasTrial
    ? `Your ${trialPeriodDays}-day trial will last until ${trialEndDate}. ` +
      `Unless you cancel beforehand, your payment method will be charged ${initialPlanPrice}`
    : `Your payment method will be charged ${initialPlanPrice}`;

  if (hasOneTimeDiscount) {
    purchaseChargeText +=
      `. After that, your payment method will be automatically charged ${ongoingPlanPrice} ` +
      `every ${planInterval?.inText} until you cancel.`;
  } else {
    purchaseChargeText += `, renewing every ${planInterval?.inText} until you cancel.`;
  }

  return initialPlanPrice && ongoingPlanPrice ? (
    <LightContainer style={{ padding: '40px 1.5em 1.5em' }} data-test="disclaimer">
      <img
        src={images.certificate}
        height={69}
        alt="Certificate"
        style={{ position: 'absolute', marginLeft: -35, marginTop: -71 }}
      />
      <Body>{purchaseChargeText}</Body>
      <Body>You can cancel anytime via the Subscription screen within the app settings.</Body>
    </LightContainer>
  ) : (
    <></>
  );
};
